// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--aX13T","close":"_4f720283bf--close--Dl4SH","left":"_4f720283bf--left--OuPee","title":"_4f720283bf--title--majei"};